import { authenticatedFetch } from '../../api/apiClient';

const BASE = '/api/v2/users/me/phone';

async function parseJson(respOrPromise) {
  const resp = await respOrPromise;
  if (!resp || typeof resp.json !== 'function') {
    throw new Error('Phone API returned an unexpected response');
  }
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const err = new Error(data.error || data.message || `Request failed (${resp.status})`);
    err.detail = data.detail;
    err.status = resp.status;
    throw err;
  }
  return data.data ?? data;
}

export const getPhoneConfig = () =>
  parseJson(authenticatedFetch(`${BASE}/config`));

export const validateDial = (phone) =>
  parseJson(authenticatedFetch(`${BASE}/validate-dial`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone }),
  }));

export const listPhoneContacts = () =>
  parseJson(authenticatedFetch(`${BASE}/contacts`)).then((d) => d.contacts || []);

export const createPhoneContact = (payload) =>
  parseJson(authenticatedFetch(`${BASE}/contacts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })).then((d) => d.contact);

export const updatePhoneContact = (id, payload) =>
  parseJson(authenticatedFetch(`${BASE}/contacts/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })).then((d) => d.contact);

export const deletePhoneContact = (id) =>
  parseJson(authenticatedFetch(`${BASE}/contacts/${id}`, { method: 'DELETE' }));

export const listPhoneRecents = () =>
  parseJson(authenticatedFetch(`${BASE}/recents`)).then((d) => d.recents || []);

export const listSipTargets = () =>
  parseJson(authenticatedFetch(`${BASE}/sip-targets`)).then((d) => d.targets || []);

export const resolveSipTarget = (extension) =>
  parseJson(authenticatedFetch(`${BASE}/sip-targets/resolve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ extension }),
  })).then((d) => d.target);

export const appendPhoneRecent = (payload) =>
  parseJson(authenticatedFetch(`${BASE}/recents`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }));
